import { PaymentOption } from '@navio/nsdk';

export function shouldPayForOrder({
  paymentMethodInTireOffer,
  isPaid,
  isSelected
}: {
  paymentMethodInTireOffer: PaymentOption;
  isPaid: boolean;
  isSelected: boolean;
}) {
  return !isPaid && paymentMethodInTireOffer === PaymentOption.PAY_BEFORE && isSelected;
}
